import { AxiosRequestConfig } from "axios";
import http from "../base/http.service";
import { NoContentDto } from "../base/base.dto";
import { AccessTokenDto, RefreshTokenDto, LoginDto, OsbukLoginTokenDto } from "./auth.dto";

const services = {
  CreateTokenOsb(dto: LoginDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<AccessTokenDto>("auth/loginosb", dto, config);
  },
  
  CreateToken(dto: LoginDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<AccessTokenDto>("auth/login", dto, config);
  },

  RevokeRefreshToken(refreshTokenDto: RefreshTokenDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<NoContentDto>(`auth/revokerefreshtoken`, refreshTokenDto, config);
  },

  CreateTokenByRefreshToken(dto: RefreshTokenDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<AccessTokenDto>("auth/createaccesstokenfromrefreshtoken", dto, config);
  },

  LoginOsb_1(dto: LoginDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<OsbukLoginTokenDto>("auth/login_osb", dto, config);
  }
};

export default services;
